import { apiRequest } from '../../client';
import { tryGetApiToken } from '../../authToken';

async function withClientToken(path, options = {}) {
  const token = await tryGetApiToken();
  return apiRequest(path, { ...options, token });
}

export async function patchStorefrontCalendarIntegrations({ companyId, clientId, google, outlook }) {
  const calendarIntegrations = {};
  if (google !== undefined) calendarIntegrations.google = google === true;
  if (outlook !== undefined) calendarIntegrations.outlook = outlook === true;
  const result = await withClientToken(
    `/api/public/companies/${encodeURIComponent(companyId)}/clients/${encodeURIComponent(clientId)}/calendar-integrations`,
    {
      method: 'PATCH',
      body: { calendarIntegrations },
    }
  );
  return result.client || null;
}

export async function patchStorefrontAppointmentCalendar({ companyId, appointmentId, patch }) {
  return withClientToken(
    `/api/public/companies/${encodeURIComponent(companyId)}/appointments/${encodeURIComponent(appointmentId)}/calendar-event`,
    {
      method: 'PATCH',
      body: patch,
    }
  );
}
